import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Importation } from "../../../models/importation";
import { ImportedPickup } from "../../../models/imported-pickup";
import { UserViewService } from "../../../../../shared/sub-modules/user-views/services/user-view.service";
import { environment } from "../../../../../../../src/environments/environment";

/** ImportedPickupsService */
@Injectable()
export class ImportedPickupsService extends UserViewService {
  urlBase = environment.urlPickups;
  /** ImportedPickupsService */
  constructor(http: HttpClient) {
    super("historical-imports-detail", http);
  }

  /** Obtiene el detalle de una importacion */
  detail(number: string): Observable<Importation> {
    return this.http.get<Importation>(`${this.urlBase}import-detail`, {
      params: new HttpParams().set("ImportNumber", number),
    });
  }

  /** Obtiene el detalle de una recogida importada */
  importedDetailPickups(
    importationNumber: string,
    importationIdNumber: string
  ): Observable<ImportedPickup> {
    return this.http.get<ImportedPickup>(
      `${this.urlBase}imported-pickup-detail`,
      {
        params: new HttpParams()
          .set("importNumber", importationNumber)
          .set("importIdNumber", importationIdNumber),
      }
    );
  }
}
